import * as React from 'react';

type ActionDetailsIconP = {
    active: boolean;
    onClick: Function;
    title: string;
    iconSrc: string;
    rotate?: boolean;
    e2eId?:string;
};

export const ActionDetailsIcon = (props: ActionDetailsIconP) => {
    return (
        <div className={`details-right__dashboard-item ${props.active ? '' : 'details-right__dashboard-item--disabled'} `} date-e2eid={props.e2eId} onClick={() => props.onClick()}>
            <img className={`details-right__dashboard-icon ${props.rotate ? 'details-right__dashboard-icon--rotate-45' : ''}`} src={props.iconSrc} alt="" /> <span>{props.title}</span>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/HelperFunctions/DetailsSidebarHelpers.tsx